<app-navbar *ngIf="auth.userData"></app-navbar>
<div class="app-inner-routes">
  <ng-content class="content"></ng-content>
</div>
